import logo from '../../assets/logo.png';
import { Logo } from './styles';

const LogoImg = () => <Logo src={logo} alt="Pêssego" layoutId="logo" transition={{ duration: 1 }} />;

export default LogoImg;
